import React from "react";
import "./OtherTransactionReport.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function OtherTransactionReport(props) {
  const data = props.data;
  return (
    <div className="report-main" style={{ width: "100%" }}>
      <div
        className="header-main"
        style={{
          display: "flex",
          padding: "0.5rem",
          alignItems: " center",
          height: "40px",
        }}
      >
        <FontAwesomeIcon
          icon={data.Icon}
          style={{ color: "#0758e4", margin: "5px", fontSize: "20px" }}
        />

        <h4
          className="object"
          style={{
            margin: "5px",
            fontSize: "1.1rem",
            fontWeight: "600",
            marginBottom: "2px",
          }}
        >
          {data.title}
        </h4>
      </div>
      <div
        className="Loki"
        style={{
          borderBottomStyle: "dashed ",
          borderBottomColor: "#d8d8dc",
          padding: "9px",
        }}
      >
        <span>
          <strong style={{ fontSize: "1.3rem", marginLeft: "4px" }}>
            {data.total}
          </strong>
          <span className="lightly-text" style={{ fontSize: "1rem" }}>
            {" "}
            / Total
          </span>
        </span>
      </div>
      <div className="Content" style={{ marginTop: "0.5rem" }}>
        <div className="Left" style={{ marginLeft: "8px" }}>
          <span
            className="lightly-text"
            style={{ fontSize: "1rem", display: "block" }}
          >
            New
          </span>

          <strong style={{ color: "#06741A" }}>{data.new}</strong>
        </div>
        <div
          style={{
            marginLeft: "40px",
            borderLeft: "1px solid #d8d8dc",
            padding: "2px 9px",
          }}
        >
          <span
            className="lightly-text"
            style={{ fontSize: "1rem", display: "block" }}
          >
            Deleted
          </span>
          <strong style={{ color: "#C4061A" }}>{data.deleted}</strong>
        </div>
      </div>
    </div>
  );
}

export default OtherTransactionReport;
